<template>
  <div class="filters-container">
    <div class="placeholder" />
    <PurchasesTreeTableFilterItem
      v-for="column in filterColumns"
      :key="column.field"
      :field="column.field"
      :type="column.type"
      :filter-path="column.filterPath"
      :operation="column.operation"
      :width="column.width"
    />
  </div>
</template>

<script>
import PurchasesTreeTableFilterItem from "./PurchasesTreeTableFilterItem.vue";
import filtersConfig from "./purchasesTreeTableFiltersConfig.js";

export default {
  name: "PurchasesTreeTableFilters",
  components: {
    PurchasesTreeTableFilterItem,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    widths: {
      type: Object,
      required: true,
    },
    isResizing: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    filterColumns() {
      return this.columns
        .filter((column) => !column.hidden)
        .map((column) => ({
          field: column.field,
          width: this.widths[column.field],
          ...filtersConfig[column.field],
        }))
        .filter((column) => column.filterPath);
    },
  },
};
</script>

<style lang="less" scoped>
.filters-container {
  width: max-content;
  min-width: 100%;
  display: flex;
  min-height: 26px;
  background-color: #edeff1;
  position: sticky;
  top: 48px;
  z-index: 10;
  .placeholder {
    background-color: #edeff1;
    width: calc(76px + 14px + 14px);
    position: sticky;
    left: 0;
    z-index: 11;
  }
}
</style>
